var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBroadcaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 15.5361L16.9547 4.09524C16.8374 3.87293 16.9219 3.59686 17.1438 3.47933L17.9474 3.05293C18.1692 2.9354 18.4447 3.02013 18.5619 3.24244L23.0001 11.642L27.4383 3.24244C27.5556 3.02013 27.831 2.9354 28.0529 3.05293L28.8565 3.47933C29.0783 3.59686 29.1628 3.87293 29.0456 4.09524L23.0001 15.5361Z",
    fill: "url(#paint0_linear_2565_14093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 17.8439C25.2594 17.8439 27.091 16.0083 27.091 13.7439C27.091 11.4796 25.2594 9.64392 23.0001 9.64392C20.7407 9.64392 18.9092 11.4796 18.9092 13.7439C18.9092 16.0083 20.7407 17.8439 23.0001 17.8439Z",
    fill: "url(#paint1_linear_2565_14093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81818 39.7105H41.1818C42.1864 39.7105 43 38.8951 43 37.8883V14.1994C43 13.1926 42.1864 12.3772 41.1818 12.3772H4.81818C3.81364 12.3772 3 13.1926 3 14.1994V37.8883C3 38.8951 3.81364 39.7105 4.81818 39.7105Z",
    fill: "#015A93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.182 14.1995H4.81836V37.8884H41.182V14.1995Z",
    fill: "url(#paint2_linear_2565_14093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2729 41.5327H28.4548V39.7104H17.5457V41.5327H10.7275C10.4766 41.5327 10.2729 41.7368 10.2729 41.9882V42.8993C10.2729 43.1508 10.4766 43.3549 10.7275 43.3549H35.2729C35.5239 43.3549 35.7275 43.1508 35.7275 42.8993V41.9882C35.7275 41.7368 35.5239 41.5327 35.2729 41.5327Z",
    fill: "url(#paint3_linear_2565_14093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M24.7909 26.0438C23.8036 26.0438 23 25.2384 23 24.2489V17.8165C23 16.827 23.8036 16.0216 24.7909 16.0216H37.5727C38.56 16.0216 39.3636 16.827 39.3636 17.8165V24.2499C39.3636 25.2393 38.56 26.0447 37.5727 26.0447H24.7909V26.0438Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M24.791 25.5883C24.0537 25.5883 23.4546 24.9879 23.4546 24.249V17.8165C23.4546 17.0776 24.0546 16.4772 24.791 16.4772H37.5728C38.31 16.4772 38.9091 17.0776 38.9091 17.8165V24.2499C38.9091 24.9888 38.3091 25.5892 37.5728 25.5892H24.791V25.5883Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5728 25.1327H24.791C24.3037 25.1327 23.9092 24.7373 23.9092 24.249V17.8165C23.9092 17.3282 24.3037 16.9327 24.791 16.9327H37.5728C38.0601 16.9327 38.4546 17.3282 38.4546 17.8165V24.249C38.4546 24.7373 38.0601 25.1327 37.5728 25.1327Z",
    fill: "#DDD8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M24.7909 36.066C23.8036 36.066 23 35.2606 23 34.2712V27.8387C23 26.8492 23.8036 26.0438 24.7909 26.0438H37.5727C38.56 26.0438 39.3636 26.8492 39.3636 27.8387V34.2721C39.3636 35.2615 38.56 36.067 37.5727 36.067H24.7909V36.066Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M24.791 35.6105C24.0537 35.6105 23.4546 35.0101 23.4546 34.2712V27.8387C23.4546 27.0998 24.0546 26.4994 24.791 26.4994H37.5728C38.31 26.4994 38.9091 27.0998 38.9091 27.8387V34.2721C38.9091 35.011 38.3091 35.6114 37.5728 35.6114H24.791V35.6105Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5728 35.155H24.791C24.3037 35.155 23.9092 34.7595 23.9092 34.2712V27.8387C23.9092 27.3504 24.3037 26.955 24.791 26.955H37.5728C38.0601 26.955 38.4546 27.3504 38.4546 27.8387V34.2712C38.4546 34.7595 38.0601 35.155 37.5728 35.155Z",
    fill: "#95F9FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M8.42714 26.0438C7.43987 26.0438 6.63623 25.2384 6.63623 24.2489V17.8165C6.63623 16.827 7.43987 16.0216 8.42714 16.0216H21.209C22.1962 16.0216 22.9999 16.827 22.9999 17.8165V24.2499C22.9999 25.2393 22.1962 26.0447 21.209 26.0447H8.42714V26.0438Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M8.42718 25.5883C7.68991 25.5883 7.09082 24.9879 7.09082 24.249V17.8165C7.09082 17.0776 7.69082 16.4772 8.42718 16.4772H21.209C21.9463 16.4772 22.5454 17.0776 22.5454 17.8165V24.2499C22.5454 24.9888 21.9454 25.5892 21.209 25.5892H8.42718V25.5883Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.209 25.1327H8.42723C7.93996 25.1327 7.54541 24.7373 7.54541 24.249V17.8165C7.54541 17.3282 7.93996 16.9327 8.42723 16.9327H21.209C21.6963 16.9327 22.0909 17.3282 22.0909 17.8165V24.249C22.0909 24.7373 21.6963 25.1327 21.209 25.1327Z",
    fill: "#9FE8FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M8.42714 36.066C7.43987 36.066 6.63623 35.2606 6.63623 34.2712V27.8387C6.63623 26.8492 7.43987 26.0438 8.42714 26.0438H21.209C22.1962 26.0438 22.9999 26.8492 22.9999 27.8387V34.2721C22.9999 35.2615 22.1962 36.067 21.209 36.067H8.42714V36.066Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M8.42718 35.6105C7.68991 35.6105 7.09082 35.0101 7.09082 34.2712V27.8387C7.09082 27.0998 7.69082 26.4994 8.42718 26.4994H21.209C21.9463 26.4994 22.5454 27.0998 22.5454 27.8387V34.2721C22.5454 35.011 21.9454 35.6114 21.209 35.6114H8.42718V35.6105Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.209 35.155H8.42723C7.93996 35.155 7.54541 34.7595 7.54541 34.2712V27.8387C7.54541 27.3504 7.93996 26.955 8.42723 26.955H21.209C21.6963 26.955 22.0909 27.3504 22.0909 27.8387V34.2712C22.0909 34.7595 21.6963 35.155 21.209 35.155Z",
    fill: "#FFEDFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2565_14093",
    x1: 23.0001,
    y1: 6.3302,
    x2: 23.0001,
    y2: 10.2525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0261C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2565_14093",
    x1: 23.0001,
    y1: 9.76054,
    x2: 23.0001,
    y2: 12.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0680CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2565_14093",
    x1: 19.3629,
    y1: 14.2988,
    x2: 27.0677,
    y2: 39.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2565_14093",
    x1: 23.0002,
    y1: 39.7032,
    x2: 23.0002,
    y2: 43.3622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#015A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2E96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#3597E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBroadcaster);
export default __webpack_public_path__ + "static/media/logo_broadcaster.5bb2dedbd58eae12d75ac5c72ca3f7ef.svg";
export { ForwardRef as ReactComponent };